import { $host } from "./index";
import { TEditTask, TEditCourse, TCreateCourse } from "../types";

export default class AdminService {
  static async lockTaskForEdit(id: number) {
    return await $host.put("admin/task/lock/" + id);
  }

  static async unlockEditedTask(id: number) {
    return await $host.put("admin/task/unlock/" + id);
  }

  static async lockCourseForEdit(id: number) {
    throw new Error("Method not implemented.");
  }

  static async getCourseById(id: number) {
    return await $host.get("admin/course/" + id);
  }

  static async getTaskById(id: number) {
    return await $host.get("admin/task/" + id);
  }

  static async getHintsByTaskId(id: number) {
    return await $host.get("admin/task/hints/" + id);
  }

  static async putUpdatedTask(data: TEditTask) {
    return await $host.put("admin/task/" + data.id, data);
  }

  static async putUpdatedCourse(data: TEditCourse) {
    return await $host.put("admin/course/" + data.id, data);
  }

  static async createTask(data: TEditTask) {
    data.id = 0;
    return await $host.post("admin/task", data);
  }

  static async createCourse(data: TCreateCourse) {
    data.id = 0;
    return await $host.post("admin/course", data);
  }

  static async addTaskToCourse(courseId: number, taskId: number) {
    return await $host.post("admin/course/" + courseId + "/task/" + taskId);
  }

  static async addTaskToCourseWithOrder(
    courseId: number,
    taskId: number,
    order: number,
  ) {
    return await $host.post(
      "admin/course/" + courseId + "/task/" + taskId + "/order/" + order,
    );
  }

  static async deleteTaskFromCourse(courseId: number, taskId: number) {
    return await $host.delete("admin/course/" + courseId + "/task/" + taskId);
  }

  static async setTaskOrder(courseId: number, taskId: number, order: number) {
    return await $host.put(
      "admin/course/" + courseId + "/task/" + taskId + "/order/" + order,
    );
  }

  /**
   * Метод для загрузки файла
   * @param data - обновленные данные
   * @param type - тип файла (course or task)
   * @param field - поле для обновления в БД (solutionImage, questionImage, image)
   * @param id - айди строки для обновления
   * @return {Promise<any>}
   */
  static async uploadFile(
    data: any,
    type: string,
    field: string,
    id: number,
  ): Promise<any> {
    return await $host.post("admin/file/" + type + "/" + id, data, {
      data: { field },
    });
  }

  static async deleteFile(type: string, field: string, id: number) {
    return await $host.delete("admin/file/" + type + "/" + field + "/" + id);
  }

  static async getAnswer25Info(id: number, days: number) {
    return await $host.get("info/answer25", { params: { id, days } });
  }

  static async getReport83(id: number, days: number) {
    return await $host.get("info/report83", { params: { id, days } });
  }

  static async getReportsList() {
    return await $host.get("info/reportslist");
  }

  static async runReport(report: string, params: string) {
    return await $host.get("info/runreport", { params: { report, params } });
  }

  static async getGenerators() {
    return await $host.get("info/generators");
  }

  static async saveGenerator(data: any) {
    return await $host.post("info/generator/" + data.id, data);
  }
}
